import { useCallback, useEffect, useState } from "react";
import { getMyRegistrations } from "../api/getMyRegistrations/getMyRegistrationsApi";
import { MyRegistrationItem } from "../api/getMyRegistrations/types";

export function useMyRegistrations() {
  const [registrations, setRegistrations] = useState<MyRegistrationItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getMyRegistrations();
      setRegistrations(response.data.registrations);
    } catch {
      setError("Failed to load registrations.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const now = new Date().toISOString();

  const upcoming = registrations.filter(
    (r) => !r.startDate || r.startDate >= now,
  );
  const past = registrations.filter(
    (r) => r.startDate && r.startDate < now,
  );

  return { upcoming, past, loading, error, refetch: fetch };
}
